const EASY_SOIL = 1;
const MEDIUM_HARD_SOIL = 2;
const HARD_SOIL = 3;


export default {
    EASY_SOIL: EASY_SOIL,
    MEDIUM_HARD_SOIL: MEDIUM_HARD_SOIL,
    HARD_SOIL: HARD_SOIL,
}